import { render, staticRenderFns } from "./TrangRouter.vue?vue&type=template&id=0de59a70&"
import script from "./TrangRouter.vue?vue&type=script&lang=js&"
export * from "./TrangRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports